import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {MatterId} from "common/types/matter";

export type MatterDeleteAction = {
  type: MattersActionTypes["MATTER_DELETE"]["SUCCESS"];
  payload: {matterId: MatterId};
};

export default function deleteMatter(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_DELETE,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
    ) => {
      return requestor
        .delete(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
